import React from 'react'
import { Card } from '@mobi/component-library/Base/Card'
import { getTicketLayoutType } from '@core/Areas/Account/Pages/Activity/Components/Ticket/helpers'
import { TicketDisplayContext } from '@core/Areas/Account/Pages/Activity/context'
import type { Ticket } from '@core/Areas/Account/Pages/Activity/types'
import type { NextSkyRace } from '@core/Areas/RaceCardSky/types'
import { GeneralTicket } from './Components/GeneralTicket'
import { MultiTicket } from './Components/MultiTicket'

export const SkyPendingTicket: React.FC<{ ticket: Ticket; nextSkyRaces: NextSkyRace[] }> = ({
  ticket,
  nextSkyRaces,
}) => {
  const ticketType = getTicketLayoutType(ticket)
  const isMulti = ticketType === 'multi'

  return (
    <TicketDisplayContext.Provider
      value={{ type: 'pending-bets-drawer', data: { isSkyRaceMatch: false } }}
    >
      <Card>
        {isMulti ? (
          <MultiTicket ticket={ticket} nextSkyRaces={nextSkyRaces} />
        ) : (
          <GeneralTicket ticket={ticket} nextSkyRaces={nextSkyRaces} ticketType={ticketType} />
        )}
      </Card>
    </TicketDisplayContext.Provider>
  )
}
